import { render, staticRenderFns } from "./Unattended.vue?vue&type=template&id=2d3848a5"
import script from "./Unattended.vue?vue&type=script&lang=js"
export * from "./Unattended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports